"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");exports.__esModule=true;exports.default=_default;var _canvas=_interopRequireDefault(require("../_internal/components/canvases/canvas"));var _lib=require("@fusioncharts/core/src//lib");function _default(chart){var canvas;(0,_lib.componentFactory)(chart,_canvas.default,"canvas",chart.config.showVolumeChart?2:1);canvas=chart.getChildren("canvas");for(var i=0,len=canvas.length;i<len;i++){canvas[i].configure()}}


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/charts/src/factories/canvas.js
// module id = U9B+
// module chunks = 5